import React from 'react';

export function PayloadViewerDialogShimmer() {
  return (
    <div className='py-5'>
      <div className='shimmer shimmer-line' style={{ width: '100px', height: '10px', marginBottom: '12px' }} />
      <div className='shimmer shimmer-line' style={{ width: '210px', height: '10px', marginBottom: '12px' }} />
      <div className='shimmer shimmer-line' style={{ width: '160px', height: '10px', marginBottom: '12px' }} />
      <div className='shimmer shimmer-line' style={{ width: '240px', height: '10px', marginBottom: '12px' }} />
      <div className='shimmer shimmer-line' style={{ width: '100px', height: '10px', marginBottom: '12px' }} />
      <div className='shimmer shimmer-line' style={{ width: '160px', height: '10px', marginBottom: '12px' }} />
    </div>
  );
}
